import { Alert } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../contexts/LanguageContext'
import Language from '../enums/Language'
import { ConfluencePages } from '../enums'
import { useConfluencePage } from '../hooks/useConfluencePage'
import ConfluencePageArticle from './ConfluencePageArticle'

export default function HeaterEnterCustomerReferenceInstructions() {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The language.
   */
  const { language } = useLanguage()

  /**
   * The Confluence page ID.
   */
  const pageId = initializePageId()

  /**
   * Initialize the Confluence page ID based on the current language.
   */
  function initializePageId(): string {
    switch (language) {
      case Language.FINNISH:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_FI
      case Language.SWEDISH:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_SE
      case Language.NORWEGIAN_BOKMÅL:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_NO
      case Language.GERMAN:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_DE
      case Language.FRENCH:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_FR
      case Language.SPANISH:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_ES
      case Language.DUTCH:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_NL
      case Language.ENGLISH_US:
      default:
        return ConfluencePages.INSTALLATION_HEATER_ENTER_CUSTOMER_REFERENCE_INSTRUCTIONS_EN
    }
  }

  /**
   * The Confluence page.
   */
  const { page, isLoading } = useConfluencePage(pageId)

  if (isLoading) {
    return null
  }

  return (
    <>
      {page ? (
        <ConfluencePageArticle page={page} />
      ) : (
        <Alert severity="info">
          {t('installation:youMaySkipThisStepIfYouWantToCreateNewHeaterWithoutCustomerReference')}
        </Alert>
      )}
    </>
  )
}
